import { ConfigForData } from '@droplet-tech-code/core-common-types';

import { useCallback } from 'react';

import { useFormModal } from '~/components/Modals/FormModal';
import {
  supportRequestActionsApi,
  SupportRequestGetCfarQuoteRequest,
} from '~/screens/Support/Requests/supportRequestActions.api';
import { translate } from '~/utils/translation.utils';
import { onSubmitValue } from '../utils/utils';
import { DATE_TIME_SERVER_FORMAT } from '~/utils/date.utils';

export const useGetCfarQuote = ({
  supportId,
  bookingId,
  cfarDetails,
  currency,
  check,
}: {
  supportId: string;
  bookingId?: string;
  currency?: string;
  cfarDetails?: {
    passengerCount: number;
    departureDateTime: string;
  };
  check: string;
}) => {
  const { open: openForm, close: closeForm } = useFormModal();

  let useFormHookHandler = useCallback(() => {
    const config: ConfigForData = [
      {
        items: [
          {
            id: 'newPrice',
            label: `${translate('supportRequests.cfar.newBookingPrice')} ${currency || ''}`,
            type: 'number',
          },
        ],
      },
      {
        items: [
          {
            id: 'passengerCount',
            label: translate('supportRequests.cfar.passengerCount'),
            type: 'number',
            initialValue: cfarDetails?.passengerCount,
          },
        ],
      },
      {
        items: [
          {
            id: 'newDepartureDateTime',
            label: translate('supportRequests.cfar.newDepartureDateTime'),
            type: 'date',
            format: DATE_TIME_SERVER_FORMAT,
            initialValue: cfarDetails?.departureDateTime,
            optional: true,
          },
        ],
      },
    ];
    return { data: { config }, isLoading: false };
  }, [currency]);

  const onConfirm = async ({
    action,
    value,
  }: {
    action: (req: SupportRequestGetCfarQuoteRequest) => void;
    value: SupportRequestGetCfarQuoteRequest['cfarDetails'];
  }) => {
    if (!bookingId) {
      return;
    }
    return await action({
      cfarDetails: { ...value, newPrice: onSubmitValue(value.newPrice) },
      bookingId,
      check,
      supportId,
    });
  };

  return {
    open: () => {
      openForm({
        modalTitle: translate('supportRequests.cfar.createNewCfarQuote'),
        useFormHookHandler,
        onConfirm,
        actionHook: supportRequestActionsApi.useGetCfarQuoteMutation,
      });
    },
    close: () => {
      closeForm();
    },
  };
};
